import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from '@reach/router';
import { useSelector, useDispatch } from 'react-redux';
import { buildAlertaObj } from './errorHelper';
import { exibeAlerta } from '../redux/actions/alertActions';
// import { traduzNomeRota } from './traduzNomeRota';

const PrivateRouteObj = ({ component: Component, permissoes, ...rest }) => {
    const login = useSelector(state => state.login);
    const dispatch = useDispatch();
    const getRoute = () => {
        let erroObj;
        if (login && login.token) {
            if (
                permissoes.length === 0 ||
                permissoes.some(r => login.permissoes.indexOf(r) !== -1)
            ) {
                return <Component {...rest} />;
            }
            erroObj = buildAlertaObj(
                'Aguarde',
                `A página está sendo atualizada.`
            );
        } else {
            erroObj = buildAlertaObj(
                'Aguarde',
                `A página está sendo atualizada.`
            );
        }
        dispatch(exibeAlerta(erroObj));
        return (
            <Redirect
                from=''
                to={`${process.env.REACT_APP_BASE_URL}`}
                noThrow
            />
        );
    };

    return getRoute();
};

PrivateRouteObj.propTypes = {
    component: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
        .isRequired,
    scopes: PropTypes.arrayOf(PropTypes.string)
};

PrivateRouteObj.defaultProps = {
    scopes: []
};

export const PrivateRoute = PrivateRouteObj;
